<script setup lang="ts">
import BlankLayout from '@/layouts/BlankLayout.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { logout } from '@/modules/authentication/authenticationService'
import { useAuth } from '@/modules/authentication/authStore'
import { getLayout } from '@/services/localStorage'
import { computed, onBeforeMount, ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const store = useAuth()
const authLoaded = ref(false)

onBeforeMount(async () => {
  try {
    await store.authLoaded
    authLoaded.value = true
  }
  catch (error) {
    console.error('Failed to load authentication:', error)
    await logout()
  }
})

const layout = computed(() => getLayout() || route.meta.layout || 'default')

const layoutComponent = computed(() => {
  switch (layout.value) {
    case 'blank':
      return BlankLayout
    case 'default':
    default:
      return DefaultLayout
  }
})
</script>

<template>
  <component :is="layoutComponent">
    <transition v-if="authLoaded" name="fade" mode="out-in">
      <router-view :key="route.fullPath" />
    </transition>
  </component>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
